import {
  DropdownSingleSelect,
  type DropdownSingleSelectProps,
} from './components/DropdownSingleSelect/DropdownSingleSelect';
import {
  DropdownSingleSelectAsync,
  type DropdownSingleSelectAsyncProps,
} from './components/DropdownSingleSelectAsync/DropdownSingleSelectAsync';
import {
  DropdownTreeSingleSelect,
  type DropdownTreeSingleSelectProps,
} from './components/DropdownTreeSingleSelect/DropdownTreeSingleSelect';
import {
  MultiSelect,
  type MultiSelectProps,
} from './components/MultiSelect/MultiSelect';
import {
  SortableMultiSelect,
  type SortableMultiSelectProps,
} from './components/SortableMultiSelect/SortableMultiSelect';

function SelectSingle<TOptionProps = unknown>(
  props: DropdownSingleSelectProps<TOptionProps>,
) {
  return <DropdownSingleSelect<TOptionProps> {...props} />;
}

SelectSingle.displayName = 'Select.Single';

function SelectSingleAsync<T, K>(props: DropdownSingleSelectAsyncProps<T, K>) {
  return <DropdownSingleSelectAsync<T, K> {...props} />;
}

SelectSingleAsync.displayName = 'Select.SingleAsync';

function SelectSingleTree<TOptionProps = unknown>(
  props: DropdownTreeSingleSelectProps<TOptionProps>,
) {
  return <DropdownTreeSingleSelect<TOptionProps> {...props} />;
}

SelectSingleTree.displayName = 'Select.SingleTree';

function SelectMulti<T>(props: MultiSelectProps<T>) {
  return <MultiSelect<T> {...props} />;
}

SelectMulti.displayName = 'Select.Multi';

function SelectMultiSortable<T>(props: SortableMultiSelectProps<T>) {
  return <SortableMultiSelect<T> {...props} />;
}

SelectMultiSortable.displayName = 'Select.MultiSortable';

export const Select = {
  Single: SelectSingle,
  SingleTree: SelectSingleTree,
  SingleAsync: SelectSingleAsync,
  Multi: SelectMulti,
  MultiSortable: SelectMultiSortable,
} as const;
